import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Grid,
  Flex,
  Badge,
  Icon,
  VStack,
  HStack,
  Button,
  SimpleGrid,
  Divider,
  useClipboard,
  useToast,
  Center,
} from '@chakra-ui/react';
import { COLORS, GRADIENTS } from '../utils/constants';
import { 
  FaCheck, 
  FaRocket, 
  FaCoins, 
  FaImage, 
  FaWallet,
  FaBrain,
  FaBolt,
  FaUserFriends,
  FaTrophy,
  FaExchangeAlt,
  FaLaughSquint,
  FaStar,
  FaCcamera,
  FaDownload,
  FaShareAlt,
  FaFire,
  FaChartLine,
  FaGlobe,
  FaDiscord,
  FaTelegram,
  FaCheckCircle,
} from 'react-icons/fa';
import { SiX } from 'react-icons/si';
import BackgroundEffects from '../components/BackgroundEffects';

function Promotional() {
  const toast = useToast();
  
  return (
    <Box position="relative" minH="100vh" pb={20}>
      {/* Add the background effects component */}
      <BackgroundEffects />
      
      <Container maxW="1400px" px={4} position="relative" zIndex={2}>
        <Box textAlign="center" pt={8} pb={10}>
          <Heading 
            fontSize={{ base: "3xl", md: "4xl" }}
            color="white"
            mb={4}
            letterSpacing="wide"
          >
            Ignita Platform
          </Heading>
          <Text color="gray.400" mb={2} fontSize="lg">
            Revolutionary AI Image Generation Platform
          </Text>
          
          <HStack spacing={4} mt={6} justify="center">
            <Badge 
              colorScheme="green" 
              bg="rgba(0, 207, 51, 0.15)" 
              color={COLORS.primary}
              px={4} 
              py={2} 
              borderRadius="md"
              fontWeight="medium"
              borderWidth="1px"
              borderColor="rgba(0, 207, 51, 0.3)"
              boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
              _hover={{
                bg: "rgba(0, 207, 51, 0.25)",
                transform: "translateY(-2px)",
                boxShadow: "0 6px 8px rgba(0, 0, 0, 0.15)",
              }}
              transition="all 0.2s"
              cursor="pointer"
            >
              XRPL POWERED
            </Badge>
            <Badge 
              colorScheme="green" 
              bg="rgba(0, 207, 51, 0.15)" 
              color={COLORS.primary}
              px={4} 
              py={2} 
              borderRadius="md"
              fontWeight="medium"
              borderWidth="1px"
              borderColor="rgba(0, 207, 51, 0.3)"
              boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
              _hover={{
                bg: "rgba(0, 207, 51, 0.25)",
                transform: "translateY(-2px)",
                boxShadow: "0 6px 8px rgba(0, 0, 0, 0.15)",
              }}
              transition="all 0.2s"
              cursor="pointer"
            >
              AI GENERATION
            </Badge>
            <Badge 
              colorScheme="green" 
              bg="rgba(0, 207, 51, 0.15)" 
              color={COLORS.primary}
              px={4} 
              py={2} 
              borderRadius="md"
              fontWeight="medium"
              borderWidth="1px"
              borderColor="rgba(0, 207, 51, 0.3)"
              boxShadow="0 4px 6px rgba(0, 0, 0, 0.1)"
              _hover={{
                bg: "rgba(0, 207, 51, 0.25)",
                transform: "translateY(-2px)",
                boxShadow: "0 6px 8px rgba(0, 0, 0, 0.15)",
              }}
              transition="all 0.2s"
              cursor="pointer"
            >
              COMMUNITY DRIVEN
            </Badge>
          </HStack>
        </Box>
        
        {/* SECTION 1: Initial Announcement Visual */}
        <Center mb={16}>
          <Box 
            w="100%" 
            maxW="900px" 
            borderRadius="xl" 
            overflow="hidden"
            position="relative"
            boxShadow="0 20px 50px rgba(0,0,0,0.5)"
            bgColor="#050d05"
          >
            {/* Background with star pattern - using same style as later cards */}
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bgGradient="linear(to-br, rgba(5,15,5,0.9), rgba(0,0,0,0.95))"
              zIndex={0}
            />
            
            {/* Star pattern background */}
            <Box 
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              opacity={0.1}
              backgroundImage="url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPgo8ZGVmcz4KPHBhdHRlcm4gaWQ9InBhdHRlcm5fc1RJajEiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgcGF0dGVyblRyYW5zZm9ybT0icm90YXRlKDApIj4KPGxpbmUgeDE9IjAiIHk9IjAiIHgyPSIwIiB5Mj0iMTAiIHN0cm9rZT0iIzAwQ0YzMyIgc3Ryb2tlLXdpZHRoPSIwLjUiLz4KPC9wYXR0ZXJuPgo8L2RlZnM+CjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjcGF0dGVybl9zVElqMSkiIC8+Cjwvc3ZnPg==')"
              backgroundSize="10px 10px"
              zIndex={0}
            />
            
            {/* Decorative elements */}
            <Box 
              position="absolute"
              top="-100px"
              left="-50px"
              width="250px"
              height="400px"
              bg={`${COLORS.primary}15`}
              filter="blur(90px)"
              transform="rotate(-45deg)"
              zIndex={0}
            />
            
            <Box 
              position="absolute"
              bottom="0"
              right="-20px"
              width="300px"
              height="300px"
              bg={`${COLORS.primary}10`}
              filter="blur(80px)"
              borderRadius="full"
              zIndex={0}
            />
            
            {/* X-style header with logo and announcement label */}
            <Box position="relative" p={8} zIndex={2}>
              <Flex align="center" justify="space-between" mb={4}>
                <Flex align="center">
                  <Image 
                    src="/IgnitaLogo.svg" 
                    fallbackSrc="https://placehold.co/40x40/001800/00CF33?text=Ignita"
                    alt="Ignita Logo" 
                    width="40px" 
                    height="40px" 
                    mr={3}
                  />
                  <Text color="white" fontWeight="bold" fontSize="lg">@Ignita</Text>
                </Flex>
                
                <Icon as={SiX} color="white" boxSize={7} />
              </Flex>
              
              <Box>
                <Badge 
                  px={4} 
                  py={1.5} 
                  bg="rgba(0,207,51,0.2)" 
                  color={COLORS.primary} 
                  borderRadius="full" 
                  fontSize="md"
                  mb={4}
                >
                  🚀 ANNOUNCING
                </Badge>
                
                <Heading 
                  as="h1" 
                  fontSize={{ base: "3xl", md: "4xl" }}
                  fontWeight="extrabold" 
                  lineHeight="1.1"
                  mb={4}
                  bgGradient={`linear(to-r, white, ${COLORS.primary})`}
                  bgClip="text"
                >
                  Introducing Ignita: <br />
                  Revolutionary AI Image Platform
                </Heading>
                
                <Text fontSize="lg" color="gray.200" mb={5} fontWeight="medium" lineHeight="1.4">
                  We're excited to announce our advanced AI image generation platform.
                  Create stunning visuals for any purpose - affordable and accessible for everyone!
                </Text>
                
                <Flex justify="center" mb={5}>
                  <Box
                    borderRadius="xl"
                    overflow="hidden"
                    boxShadow="0 10px 30px rgba(0,0,0,0.5)"
                    borderWidth="2px"
                    borderColor={COLORS.primary}
                    width="85%"
                    position="relative"
                  >
                    <Image
                      src="/images/generate-page-screenshot.png"
                      alt="Ignita Platform Generate Page"
                      width="100%"
                      height="auto"
                    />
                  </Box>
                </Flex>
                
                <Flex 
                  mt={2}
                  align="center"
                  justify="center"
                  bg="rgba(0,207,51,0.1)"
                  borderRadius="full"
                  py={2}
                  px={4}
                  maxW="230px"
                  mx="auto"
                >
                  <Icon as={FaGlobe} color={COLORS.primary} mr={2} />
                  <Text color="white" fontWeight="medium">www.ignita.io</Text>
                </Flex>
              </Box>
            </Box>
          </Box>
        </Center>
        
        {/* SECTION 2: Platform Features Visual */}
        <Center mb={16}>
          <Box 
            w="100%" 
            maxW="900px" 
            borderRadius="xl" 
            overflow="hidden"
            position="relative"
            boxShadow="0 20px 50px rgba(0,0,0,0.5)"
            bgColor="#050d05"
          >
            {/* Background with gradient overlay */}
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bgGradient="linear(to-br, rgba(5,15,5,0.9), rgba(0,0,0,0.95))"
              zIndex={0}
            />
            
            {/* Star pattern background */}
            <Box 
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              opacity={0.15}
              backgroundImage="url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPgo8ZGVmcz4KPHBhdHRlcm4gaWQ9InBhdHRlcm5fc3RhcnMiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBwYXR0ZXJuVHJhbnNmb3JtPSJyb3RhdGUoMCkiPgo8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxIiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iMTAiIHI9IjAuNSIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjEwIiByPSIxIiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjMwIiBjeT0iMzAiIHI9IjAuNyIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI3MCIgY3k9IjMwIiByPSIwLjUiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMTAiIGN5PSI1MCIgcj0iMC42IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjAuOCIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjUwIiByPSIwLjYiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMzAiIGN5PSI3MCIgcj0iMC40IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjcwIiBjeT0iNzAiIHI9IjEiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMTAiIGN5PSI5MCIgcj0iMC45IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iOTAiIHI9IjAuNiIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjkwIiByPSIwLjciIGZpbGw9IiMwMENGMzMiLz4KPC9wYXR0ZXJuPgo8L2RlZnM+CjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjcGF0dGVybl9zdGFycykiIC8+Cjwvc3ZnPg==')"
              backgroundSize="100px 100px"
              zIndex={1}
            />
            
            {/* Decorative elements */}
            <Box 
              position="absolute"
              top="-100px"
              right="-50px"
              width="250px"
              height="400px"
              bg={`${COLORS.primary}15`}
              filter="blur(90px)"
              transform="rotate(45deg)"
              zIndex={0}
            />
            
            {/* Content overlay */}
            <Box position="relative" p={8} zIndex={2}>
              <Flex align="center" justify="space-between" mb={5}>
                <Flex align="center">
                  <Image 
                    src="/IgnitaLogo.svg" 
                    fallbackSrc="https://placehold.co/40x40/001800/00CF33?text=Ignita"
                    alt="Ignita Logo" 
                    width="40px" 
                    height="40px" 
                    mr={3}
                  />
                  <Text color="white" fontWeight="bold" fontSize="lg">@Ignita</Text>
                </Flex>
                
                <Icon as={SiX} color="white" boxSize={7} />
              </Flex>
              
              <Box>
                <Badge 
                  px={4} 
                  py={1.5} 
                  bg="rgba(0,207,51,0.2)" 
                  color={COLORS.primary} 
                  borderRadius="full" 
                  fontSize="md"
                  mb={4}
                >
                  ✨ PLATFORM FEATURES
                </Badge>
                
                <Heading 
                  as="h2" 
                  fontSize={{ base: "3xl", md: "4xl" }}
                  fontWeight="extrabold" 
                  lineHeight="1.1"
                  mb={6}
                  bgGradient={`linear(to-r, white, ${COLORS.primary})`}
                  bgClip="text"
                >
                  Cutting-Edge AI For Everyone
                </Heading>
              
                <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} mt={4}>
                  <Flex 
                    bgGradient="linear(to-br, rgba(30, 220, 11, 0.15), rgba(0,0,0,0.3))"
                    borderRadius="xl"
                    p={4}
                    alignItems="flex-start"
                    borderWidth="1px"
                    borderColor="rgba(30, 220, 11, 0.3)"
                  >
                    <Center 
                      bg={`${COLORS.primary}20`} 
                      p={3} 
                      borderRadius="lg" 
                      mr={3}
                    >
                      <Icon as={FaBrain} color={COLORS.primary} boxSize={5} />
                    </Center>
                    <Box flex="1">
                      <Text fontWeight="bold" fontSize="md" color="white" mb={0.5}>
                        Advanced AI Engine
                      </Text>
                      <Text color="gray.300" fontSize="sm">
                        State-of-the-art image generation with fine-tuned models
                      </Text>
                    </Box>
                  </Flex>
                  
                  <Flex 
                    bgGradient="linear(to-br, rgba(30, 220, 11, 0.15), rgba(0,0,0,0.3))"
                    borderRadius="xl"
                    p={4}
                    alignItems="flex-start"
                    borderWidth="1px"
                    borderColor="rgba(30, 220, 11, 0.3)"
                  >
                    <Center 
                      bg={`${COLORS.primary}20`} 
                      p={3}
                      borderRadius="lg" 
                      mr={3}
                    >
                      <Icon as={FaCoins} color={COLORS.primary} boxSize={5} />
                    </Center>
                    <Box flex="1">
                      <Text fontWeight="bold" fontSize="md" color="white" mb={0.5}>
                        XGCL Token Integration
                      </Text>
                      <Text color="gray.300" fontSize="sm">
                        Use XGCL tokens for special discounts and features
                      </Text>
                    </Box>
                  </Flex>
                  
                  <Flex 
                    bgGradient="linear(to-br, rgba(30, 220, 11, 0.15), rgba(0,0,0,0.3))"
                    borderRadius="xl"
                    p={4}
                    alignItems="flex-start"
                    borderWidth="1px"
                    borderColor="rgba(30, 220, 11, 0.3)"
                  >
                    <Center 
                      bg={`${COLORS.primary}20`} 
                      p={3}
                      borderRadius="lg" 
                      mr={3}
                    >
                      <Icon as={FaBolt} color={COLORS.primary} boxSize={5} />
                    </Center>
                    <Box flex="1">
                      <Text fontWeight="bold" fontSize="md" color="white" mb={0.5}>
                        Ultra-Fast Processing
                      </Text>
                      <Text color="gray.300" fontSize="sm">
                        Generate beautiful images in seconds
                      </Text>
                    </Box>
                  </Flex>
                  
                  <Flex 
                    bgGradient="linear(to-br, rgba(30, 220, 11, 0.15), rgba(0,0,0,0.3))"
                    borderRadius="xl"
                    p={4}
                    alignItems="flex-start"
                    borderWidth="1px"
                    borderColor="rgba(30, 220, 11, 0.3)"
                  >
                    <Center 
                      bg={`${COLORS.primary}20`} 
                      p={3}
                      borderRadius="lg" 
                      mr={3}
                    >
                      <Icon as={FaTrophy} color={COLORS.primary} boxSize={5} />
                    </Center>
                    <Box flex="1">
                      <Text fontWeight="bold" fontSize="md" color="white" mb={0.5}>
                        Competitions & Rewards
                      </Text>
                      <Text color="gray.300" fontSize="sm">
                        Join weekly competitions to win XGCL tokens
                      </Text>
                    </Box>
                  </Flex>
                </SimpleGrid>
              
                <Box mt={6} p={0.5} bgGradient={`linear(to-r, ${COLORS.primary}, transparent)`} borderRadius="lg">
                  <Box
                    bg="rgba(0,0,0,0.3)"
                    backgroundImage={`linear-gradient(to right, rgba(30, 220, 11, 0.15), rgba(0,0,0,0.3))`}
                    height="140px"
                    borderRadius="lg"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    position="relative"
                    overflow="hidden"
                  >
                    {/* Background design elements */}
                    <Box 
                      position="absolute" 
                      top="0" 
                      left="0" 
                      width="100%" 
                      height="100%"
                      opacity="0.1"
                      backgroundImage={`
                        radial-gradient(circle at 10% 20%, rgba(30, 220, 11, 0.8) 0%, transparent 20%),
                        radial-gradient(circle at 90% 80%, rgba(30, 220, 11, 0.8) 0%, transparent 20%),
                        radial-gradient(circle at 50% 50%, rgba(30, 220, 11, 0.3) 0%, transparent 50%)
                      `}
                    />
                    
                    {/* Icon */}
                    <Icon 
                      as={FaImage} 
                      color={COLORS.primary} 
                      boxSize={10} 
                      mb={3} 
                      filter="drop-shadow(0 0 8px rgba(30, 220, 11, 0.5))"
                    />
                    
                    {/* Text */}
                    <Text 
                      color={COLORS.primary} 
                      fontWeight="bold" 
                      fontSize="xl"
                      filter="drop-shadow(0 0 2px rgba(0,0,0,0.8))"
                    >
                      Advanced AI Technology
                    </Text>
                    
                    {/* Animated glow effect */}
                    <Box
                      position="absolute"
                      top="50%"
                      left="-100%"
                      width="300%"
                      height="1px"
                      bg="rgba(30, 220, 11, 0.5)"
                      filter="blur(8px)"
                      transform="translateY(-50%)"
                      animation="shine 4s infinite"
                      sx={{
                        "@keyframes shine": {
                          "0%": { left: "-100%" },
                          "50%": { left: "100%" },
                          "100%": { left: "100%" }
                        }
                      }}
                    />
                  </Box>
                </Box>
              
                <Flex 
                  mt={5}
                  align="center"
                  justify="center"
                  bg="rgba(30, 220, 11, 0.1)"
                  borderRadius="full"
                  py={2}
                  px={4}
                  maxW="230px"
                  mx="auto"
                >
                  <Icon as={FaGlobe} color={COLORS.primary} mr={2} />
                  <Text color="white" fontWeight="medium">www.ignita.io</Text>
                </Flex>
              </Box>
            </Box>
          </Box>
        </Center>
        
        {/* SECTION 3: How It Works Visual */}
        <Center mb={16}>
          <Box 
            w="100%" 
            maxW="900px" 
            borderRadius="xl" 
            overflow="hidden"
            position="relative"
            boxShadow="0 20px 50px rgba(0,0,0,0.5)"
            bgColor="#050d05"
          >
            {/* Background with gradient overlay */}
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bgGradient="linear(to-br, rgba(5,15,5,0.9), rgba(0,0,0,0.95))"
              zIndex={0}
            />
            
            {/* Star pattern background */}
            <Box 
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              opacity={0.15}
              backgroundImage="url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPgo8ZGVmcz4KPHBhdHRlcm4gaWQ9InBhdHRlcm5fc3RhcnMiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBwYXR0ZXJuVHJhbnNmb3JtPSJyb3RhdGUoMCkiPgo8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxIiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iMTAiIHI9IjAuNSIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjEwIiByPSIxIiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjMwIiBjeT0iMzAiIHI9IjAuNyIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI3MCIgY3k9IjMwIiByPSIwLjUiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMTAiIGN5PSI1MCIgcj0iMC42IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjAuOCIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjUwIiByPSIwLjYiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMzAiIGN5PSI3MCIgcj0iMC40IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjcwIiBjeT0iNzAiIHI9IjEiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMTAiIGN5PSI5MCIgcj0iMC45IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iOTAiIHI9IjAuNiIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjkwIiByPSIwLjciIGZpbGw9IiMwMENGMzMiLz4KPC9wYXR0ZXJuPgo8L2RlZnM+CjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjcGF0dGVybl9zdGFycykiIC8+Cjwvc3ZnPg==')"
              backgroundSize="100px 100px"
              zIndex={1}
            />
            
            {/* Decorative elements */}
            <Box 
              position="absolute"
              bottom="-70px"
              left="-50px"
              width="250px"
              height="250px"
              bg={`${COLORS.primary}15`}
              filter="blur(90px)"
              borderRadius="full"
              zIndex={0}
            />
            
            {/* Content */}
            <Box position="relative" p={8} zIndex={2}>
              <Flex align="center" justify="space-between" mb={5}>
                <Flex align="center">
                  <Image 
                    src="/IgnitaLogo.svg" 
                    fallbackSrc="https://placehold.co/40x40/001800/00CF33?text=Ignita"
                    alt="Ignita Logo" 
                    width="40px" 
                    height="40px" 
                    mr={3}
                  />
                  <Text color="white" fontWeight="bold" fontSize="lg">@Ignita</Text>
                </Flex>
                
                <Icon as={SiX} color="white" boxSize={7} />
              </Flex>
              
              <Box>
                <Badge 
                  px={4} 
                  py={1.5} 
                  bg="rgba(0,207,51,0.2)" 
                  color={COLORS.primary} 
                  borderRadius="full" 
                  fontSize="md"
                  mb={4}
                >
                  📝 HOW IT WORKS
                </Badge>
                
                <Heading 
                  as="h1" 
                  fontSize={{ base: "3xl", md: "4xl" }}
                  fontWeight="extrabold" 
                  lineHeight="1.1"
                  mb={4}
                  bgGradient={`linear(to-r, white, ${COLORS.primary})`}
                  bgClip="text"
                >
                  Generate in Just 3 Simple Steps
                </Heading>
                
                <Text fontSize="md" color="gray.300" mb={5}>
                  Create amazing images with Ignita in minutes - it's easy, fast, and affordable!
                </Text>
                
                <Flex direction="column" gap={4}>
                  <Flex
                    align="center"
                    bgGradient="linear(to-r, rgba(30, 220, 11, 0.2), rgba(0,0,0,0.3))"
                    borderRadius="xl"
                    p={4}
                    borderWidth="1px"
                    borderColor="rgba(30, 220, 11, 0.3)"
                  >
                    <Center
                      bg={`${COLORS.primary}20`}
                      borderRadius="full"
                      boxSize="50px"
                      mr={4}
                    >
                      <Text fontSize="xl" fontWeight="bold" color={COLORS.primary}>1</Text>
                    </Center>
                    <Box flex="1">
                      <Text fontSize="lg" fontWeight="bold" color="white" mb={1}>
                        Describe Your Vision
                      </Text>
                      <Text fontSize="sm" color="gray.300">
                        Use simple text prompts to describe the image you want to create
                      </Text>
                    </Box>
                    <Icon as={FaImage} color={COLORS.primary} boxSize={6} ml={3} />
                  </Flex>
                  
                  <Flex
                    align="center"
                    bgGradient="linear(to-r, rgba(30, 220, 11, 0.2), rgba(0,0,0,0.3))"
                    borderRadius="xl"
                    p={4}
                    borderWidth="1px"
                    borderColor="rgba(30, 220, 11, 0.3)"
                  >
                    <Center
                      bg={`${COLORS.primary}20`}
                      borderRadius="full"
                      boxSize="50px"
                      mr={4}
                    >
                      <Text fontSize="xl" fontWeight="bold" color={COLORS.primary}>2</Text>
                    </Center>
                    <Box flex="1">
                      <Text fontSize="lg" fontWeight="bold" color="white" mb={1}>
                        Pay with XGCL Tokens
                      </Text>
                      <Text fontSize="sm" color="gray.300">
                        Use XGCL tokens for the lowest generation fees and exclusive features
                      </Text>
                    </Box>
                    <Icon as={FaCoins} color={COLORS.primary} boxSize={6} ml={3} />
                  </Flex>
                  
                  <Flex
                    align="center"
                    bgGradient="linear(to-r, rgba(30, 220, 11, 0.2), rgba(0,0,0,0.3))"
                    borderRadius="xl"
                    p={4}
                    borderWidth="1px"
                    borderColor="rgba(30, 220, 11, 0.3)"
                  >
                    <Center
                      bg={`${COLORS.primary}20`}
                      borderRadius="full"
                      boxSize="50px"
                      mr={4}
                    >
                      <Text fontSize="xl" fontWeight="bold" color={COLORS.primary}>3</Text>
                    </Center>
                    <Box flex="1">
                      <Text fontSize="lg" fontWeight="bold" color="white" mb={1}>
                        Get Your Images Instantly
                      </Text>
                      <Text fontSize="sm" color="gray.300">
                        Receive high-quality images in seconds to download, share, or refine
                      </Text>
                    </Box>
                    <Icon as={FaDownload} color={COLORS.primary} boxSize={6} ml={3} />
                  </Flex>
                </Flex>
                
                <Box mt={6} p={0.5} bgGradient={`linear(to-r, ${COLORS.primary}, transparent)`} borderRadius="lg">
                  <Box
                    bg="rgba(0,0,0,0.3)"
                    backgroundImage={`linear-gradient(to right, rgba(30, 220, 11, 0.15), rgba(0,0,0,0.3))`}
                    height="120px"
                    borderRadius="lg"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    position="relative"
                    overflow="hidden"
                  >
                    {/* Background design elements */}
                    <Box 
                      position="absolute" 
                      top="0" 
                      left="0" 
                      width="100%" 
                      height="100%"
                      opacity="0.1"
                      backgroundImage={`
                        linear-gradient(45deg, transparent 0%, rgba(30, 220, 11, 0.2) 25%, transparent 50%),
                        linear-gradient(-45deg, transparent 0%, rgba(30, 220, 11, 0.2) 25%, transparent 50%)
                      `}
                      backgroundSize="20px 20px"
                    />
                    
                    {/* Icon */}
                    <Icon 
                      as={FaBolt} 
                      color={COLORS.primary} 
                      boxSize={9} 
                      mb={3} 
                      filter="drop-shadow(0 0 8px rgba(30, 220, 11, 0.5))"
                    />
                    
                    {/* Text */}
                    <Text 
                      color={COLORS.primary} 
                      fontWeight="bold" 
                      fontSize="xl"
                      filter="drop-shadow(0 0 2px rgba(0,0,0,0.8))"
                    >
                      Seamless Experience
                    </Text>
                    
                    {/* Subtle moving particles */}
                    <Box
                      position="absolute"
                      width="100%"
                      height="100%"
                      opacity="0.3"
                      backgroundImage={`
                        radial-gradient(circle at 20% 30%, rgba(30, 220, 11, 1) 0%, rgba(30, 220, 11, 0) 0.5%),
                        radial-gradient(circle at 80% 70%, rgba(30, 220, 11, 1) 0%, rgba(30, 220, 11, 0) 0.5%),
                        radial-gradient(circle at 40% 90%, rgba(30, 220, 11, 1) 0%, rgba(30, 220, 11, 0) 0.5%),
                        radial-gradient(circle at 60% 10%, rgba(30, 220, 11, 1) 0%, rgba(30, 220, 11, 0) 0.5%)
                      `}
                      animation="float 8s infinite"
                      sx={{
                        "@keyframes float": {
                          "0%": { backgroundPosition: "0% 0%" },
                          "50%": { backgroundPosition: "20% 20%" },
                          "100%": { backgroundPosition: "0% 0%" }
                        }
                      }}
                    />
                  </Box>
                </Box>
                
                <Flex 
                  mt={5}
                  align="center"
                  justify="center"
                  bg="rgba(30, 220, 11, 0.1)"
                  borderRadius="full"
                  py={2}
                  px={4}
                  maxW="230px"
                  mx="auto"
                >
                  <Icon as={FaGlobe} color={COLORS.primary} mr={2} />
                  <Text color="white" fontWeight="medium">www.ignita.io</Text>
                </Flex>
              </Box>
            </Box>
          </Box>
        </Center>
        
        {/* SECTION 4: Use Cases Visual */}
        <Center mb={16}>
          <Box 
            w="100%" 
            maxW="900px" 
            borderRadius="xl" 
            overflow="hidden"
            position="relative"
            boxShadow="0 20px 50px rgba(0,0,0,0.5)"
            bgColor="#050d05"
          >
            {/* Background with gradient overlay */}
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bgGradient="linear(to-br, rgba(5,15,5,0.9), rgba(0,0,0,0.95))"
              zIndex={0}
            />
            
            {/* Star pattern background */}
            <Box 
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              opacity={0.15}
              backgroundImage="url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPgo8ZGVmcz4KPHBhdHRlcm4gaWQ9InBhdHRlcm5fc3RhcnMiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBwYXR0ZXJuVHJhbnNmb3JtPSJyb3RhdGUoMCkiPgo8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxIiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iMTAiIHI9IjAuNSIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjEwIiByPSIxIiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjMwIiBjeT0iMzAiIHI9IjAuNyIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI3MCIgY3k9IjMwIiByPSIwLjUiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMTAiIGN5PSI1MCIgcj0iMC42IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjAuOCIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjUwIiByPSIwLjYiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMzAiIGN5PSI3MCIgcj0iMC40IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjcwIiBjeT0iNzAiIHI9IjEiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMTAiIGN5PSI5MCIgcj0iMC45IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iOTAiIHI9IjAuNiIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjkwIiByPSIwLjciIGZpbGw9IiMwMENGMzMiLz4KPC9wYXR0ZXJuPgo8L2RlZnM+CjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjcGF0dGVybl9zdGFycykiIC8+Cjwvc3ZnPg==')"
              backgroundSize="100px 100px"
              zIndex={1}
            />
            
            {/* Decorative elements */}
            <Box 
              position="absolute"
              top="70%"
              right="-50px"
              width="200px"
              height="200px"
              bg={`${COLORS.primary}15`}
              filter="blur(70px)"
              borderRadius="full"
              zIndex={0}
            />
            
            {/* Content overlay */}
            <Box position="relative" p={8} zIndex={2}>
              <Flex align="center" justify="space-between" mb={5}>
                <Flex align="center">
                  <Image 
                    src="/IgnitaLogo.svg" 
                    fallbackSrc="https://placehold.co/40x40/001800/00CF33?text=Ignita"
                    alt="Ignita Logo" 
                    width="40px" 
                    height="40px" 
                    mr={3}
                  />
                  <Text color="white" fontWeight="bold" fontSize="lg">@Ignita</Text>
                </Flex>
                
                <Icon as={SiX} color="white" boxSize={7} />
              </Flex>
              
              <Box>
                <Badge 
                  px={4} 
                  py={1.5} 
                  bg="rgba(0,207,51,0.2)" 
                  color={COLORS.primary} 
                  borderRadius="full" 
                  fontSize="md"
                  mb={4}
                >
                  🎯 USE CASES
                </Badge>
                
                <Heading 
                  as="h1" 
                  fontSize={{ base: "3xl", md: "4xl" }}
                  fontWeight="extrabold" 
                  lineHeight="1.1" 
                  mb={4}
                  bgGradient={`linear(to-r, white, ${COLORS.primary})`}
                  bgClip="text"
                >
                  Endless Possibilities with Ignita
                </Heading>
                
                <Text fontSize="md" color="gray.300" mb={5}>
                  Our AI platform empowers creators, businesses, and everyday users
                </Text>
                
                <Box p={0.5} bgGradient={`linear(to-r, ${COLORS.primary}, transparent)`} borderRadius="lg" mb={5}>
                  <Box
                    bg="rgba(0,0,0,0.3)"
                    backgroundImage={`linear-gradient(to right, rgba(30, 220, 11, 0.15), rgba(0,0,0,0.3))`}
                    height="140px"
                    borderRadius="lg"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    position="relative"
                    overflow="hidden"
                  >
                    {/* Background design elements */}
                    <Box 
                      position="absolute" 
                      top="0" 
                      left="0" 
                      width="100%" 
                      height="100%"
                      opacity="0.1"
                      backgroundImage={`
                        radial-gradient(circle at 30% 30%, rgba(30, 220, 11, 0.8) 0%, transparent 15%),
                        radial-gradient(circle at 70% 70%, rgba(30, 220, 11, 0.8) 0%, transparent 15%),
                        radial-gradient(circle at 30% 70%, rgba(30, 220, 11, 0.6) 0%, transparent 10%),
                        radial-gradient(circle at 70% 30%, rgba(30, 220, 11, 0.6) 0%, transparent 10%)
                      `}
                    />
                    
                    {/* Icon */}
                    <Icon 
                      as={FaChartLine} 
                      color={COLORS.primary} 
                      boxSize={10} 
                      mb={3} 
                      filter="drop-shadow(0 0 8px rgba(30, 220, 11, 0.5))"
                    />
                    
                    {/* Text */}
                    <Text 
                      color={COLORS.primary} 
                      fontWeight="bold" 
                      fontSize="xl"
                      filter="drop-shadow(0 0 2px rgba(0,0,0,0.8))"
                    >
                      Unlimited Possibilities
                    </Text>
                    
                    {/* Subtle grid pattern */}
                    <Box
                      position="absolute"
                      top="0"
                      left="0"
                      width="100%"
                      height="100%"
                      opacity="0.05"
                      backgroundImage="linear-gradient(0deg, transparent 24%, rgba(30, 220, 11, 1) 25%, rgba(30, 220, 11, 1) 26%, transparent 27%, transparent 74%, rgba(30, 220, 11, 1) 75%, rgba(30, 220, 11, 1) 76%, transparent 77%, transparent), linear-gradient(90deg, transparent 24%, rgba(30, 220, 11, 1) 25%, rgba(30, 220, 11, 1) 26%, transparent 27%, transparent 74%, rgba(30, 220, 11, 1) 75%, rgba(30, 220, 11, 1) 76%, transparent 77%, transparent)"
                      backgroundSize="30px 30px"
                    />
                  </Box>
                </Box>
                
                <Flex 
                  mt={5}
                  align="center"
                  justify="center"
                  bg="rgba(30, 220, 11, 0.1)"
                  borderRadius="full"
                  py={2}
                  px={4}
                  maxW="230px"
                  mx="auto"
                >
                  <Icon as={FaGlobe} color={COLORS.primary} mr={2} />
                  <Text color="white" fontWeight="medium">www.ignita.io</Text>
                </Flex>
              </Box>
            </Box>
          </Box>
        </Center>
        
        {/* SECTION 5: Coming Soon Visual */}
        <Center mb={20}>
          <Box 
            w="100%" 
            maxW="900px" 
            borderRadius="xl" 
            overflow="hidden"
            position="relative"
            boxShadow="0 20px 50px rgba(0,0,0,0.5)"
            bgColor="#050d05"
          >
            {/* Background with gradient overlay */}
            <Box
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              bgGradient="linear(to-br, rgba(5,15,5,0.9), rgba(0,0,0,0.95))"
              zIndex={0}
            />
            
            {/* Star pattern background */}
            <Box 
              position="absolute"
              top={0}
              left={0}
              right={0}
              bottom={0}
              opacity={0.15}
              backgroundImage="url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiPgo8ZGVmcz4KPHBhdHRlcm4gaWQ9InBhdHRlcm5fc3RhcnMiIHBhdHRlcm5Vbml0cz0idXNlclNwYWNlT25Vc2UiIHdpZHRoPSIxMDAiIGhlaWdodD0iMTAwIiBwYXR0ZXJuVHJhbnNmb3JtPSJyb3RhdGUoMCkiPgo8Y2lyY2xlIGN4PSIxMCIgY3k9IjEwIiByPSIxIiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iMTAiIHI9IjAuNSIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjEwIiByPSIxIiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjMwIiBjeT0iMzAiIHI9IjAuNyIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI3MCIgY3k9IjMwIiByPSIwLjUiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMTAiIGN5PSI1MCIgcj0iMC42IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iNTAiIHI9IjAuOCIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjUwIiByPSIwLjYiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMzAiIGN5PSI3MCIgcj0iMC40IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjcwIiBjeT0iNzAiIHI9IjEiIGZpbGw9IiMwMENGMzMiLz4KPGNpcmNsZSBjeD0iMTAiIGN5PSI5MCIgcj0iMC45IiBmaWxsPSIjMDBDRjMzIi8+CjxjaXJjbGUgY3g9IjUwIiBjeT0iOTAiIHI9IjAuNiIgZmlsbD0iIzAwQ0YzMyIvPgo8Y2lyY2xlIGN4PSI5MCIgY3k9IjkwIiByPSIwLjciIGZpbGw9IiMwMENGMzMiLz4KPC9wYXR0ZXJuPgo8L2RlZnM+CjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjcGF0dGVybl9zdGFycykiIC8+Cjwvc3ZnPg==')"
              backgroundSize="100px 100px"
              zIndex={1}
            />
            
            {/* Content overlay */}
            <Box position="relative" p={8} zIndex={2} height="100%">
              <Flex align="center" justify="space-between" mb={4}>
                <Flex align="center">
                  <Image 
                    src="/IgnitaLogo.svg" 
                    fallbackSrc="https://placehold.co/40x40/001800/00CF33?text=Ignita"
                    alt="Ignita Logo" 
                    width="40px" 
                    height="40px" 
                    mr={3}
                  />
                  <Text color="white" fontWeight="bold" fontSize="lg">@Ignita</Text>
                </Flex>
                
                <Icon as={SiX} color="white" boxSize={7} />
              </Flex>
              
              <Flex direction="column" justify="center" align="center" height="80%">
                <Badge 
                  px={4} 
                  py={1.5} 
                  bg="rgba(0,207,51,0.2)" 
                  color={COLORS.primary} 
                  borderRadius="full" 
                  fontSize="md"
                  mb={4}
                >
                  🚀 LAUNCHING SOON
                </Badge>
                
                <Heading 
                  as="h1" 
                  fontSize={{ base: "3xl", md: "4xl" }}
                  fontWeight="extrabold" 
                  lineHeight="1.1"
                  mb={5}
                  textAlign="center"
                  bgGradient={`linear(to-r, white, ${COLORS.primary})`}
                  bgClip="text"
                >
                  Join the Ignita Revolution
                </Heading>
                
                <Box
                  p={0.5}
                  bgGradient={`linear(to-r, ${COLORS.primary}, transparent)`}
                  borderRadius="lg"
                  mb={8}
                  width="90%"
                  maxW="500px"
                >
                  <Image
                    src="/images/loginPageScreenshot.png"
                    alt="Ignita Login Page"
                    width="100%"
                    height="auto"
                    borderRadius="lg"
                  />
                </Box>
                
                <Text 
                  fontSize="lg" 
                  color="gray.200" 
                  mb={8} 
                  maxW="80%" 
                  textAlign="center"
                  lineHeight="1.5"
                >
                  Be among the first to experience the next generation of AI-powered image generation on the XRPL
                </Text>
                
                <SimpleGrid columns={3} spacing={4} width="90%">
                  <Box 
                    p={3}
                    bg="rgba(0,0,0,0.3)" 
                    borderRadius="lg"
                    borderWidth="1px"
                    borderColor="rgba(30, 220, 11, 0.3)"
                    textAlign="center"
                  >
                    <Text fontSize="2xl" fontWeight="bold" color={COLORS.primary}>Q1</Text>
                    <Text color="white" fontSize="sm" fontWeight="bold">Public Beta</Text>
                  </Box>
                  
                  <Box 
                    p={3}
                    bg="rgba(0,0,0,0.3)" 
                    borderRadius="lg"
                    borderWidth="1px"
                    borderColor="rgba(30, 220, 11, 0.3)"
                    textAlign="center"
                  >
                    <Text fontSize="2xl" fontWeight="bold" color={COLORS.primary}>Q2</Text>
                    <Text color="white" fontSize="sm" fontWeight="bold">Full Launch</Text>
                  </Box>
                  
                  <Box 
                    p={3}
                    bg="rgba(0,0,0,0.3)" 
                    borderRadius="lg"
                    borderWidth="1px"
                    borderColor="rgba(30, 220, 11, 0.3)"
                    textAlign="center"
                  >
                    <Text fontSize="2xl" fontWeight="bold" color={COLORS.primary}>Q3</Text>
                    <Text color="white" fontSize="sm" fontWeight="bold">Advanced AI Features</Text>
                  </Box>
                </SimpleGrid>
                
                <Flex 
                  mt={8}
                  align="center"
                  justify="center"
                  bg="rgba(30, 220, 11, 0.1)"
                  borderRadius="full"
                  py={2}
                  px={4}
                  maxW="230px"
                  mx="auto"
                >
                  <Icon as={FaGlobe} color={COLORS.primary} mr={2} />
                  <Text color="white" fontWeight="medium">www.ignita.io</Text>
                </Flex>
              </Flex>
            </Box>
          </Box>
        </Center>
        
        {/* Replace screenshot instructions section with a simple footer */}
        <Center mt={20} mb={10}>
          <VStack spacing={4} maxW="600px" textAlign="center">
            <Heading 
              as="h3" 
              size="md" 
              color="white"
              bgGradient={GRADIENTS.primary}
              bgClip="text"
            >
              Ignita Platform
            </Heading>
                          <Text color="gray.400">
                A revolutionary AI image generation platform powered by XGL
              </Text>
            <HStack spacing={4} mt={2}>
              <Box as="a" href="#" color={COLORS.primary} fontSize="xl">
                <Icon as={FaDiscord} />
              </Box>
              <Box as="a" href="#" color={COLORS.primary} fontSize="xl">
                <Icon as={FaTelegram} />
              </Box>
              <Box as="a" href="#" color={COLORS.primary} fontSize="xl">
                <Icon as={SiX} />
              </Box>
            </HStack>
          </VStack>
        </Center>
      </Container>
    </Box>
  );
}

export default Promotional; 